import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";

interface IProps {
  title: string;
  open: boolean;
  handleCancelClick: () => void;
  handleOkClick: () => void;
}

const AlertDialog: React.FC<IProps> = ({
  title,
  open,
  handleCancelClick,
  handleOkClick,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog 
      open={open}
      id="alert_dialog"
      data-test-id="alert_dialog"
      aria-label="Alert dialog"
    >
      <DialogTitle
        id="alert_dialog_title"
        data-test-id="alert_dialog_title"
        aria-label="Alert dialog title"
      >
        {title}
      </DialogTitle>
      <DialogActions
        id="alert_dialog_actions"
        data-test-id="alert_dialog_actions"
        aria-label="Alert dialog actions"
      >
        <Button 
          variant="contained" 
          onClick={handleCancelClick}
          id="alert_dialog_cancel_button"
          data-test-id="alert_dialog_cancel_button"
          aria-label="Cancel button"
        >
          {t("Cancel")}
        </Button>
        <Button 
          variant="outlined" 
          onClick={handleOkClick}
          id="alert_dialog_ok_button"
          data-test-id="alert_dialog_ok_button"
          aria-label="OK button"
        >
          {t("Ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
